import React,{Component} from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { getUserDetails,updateUserDetails } from '../../../../actions/userAction';
import { Control,input,Field,actions } from 'react-redux-form';
import { hideShowPassword } from '../../../../actions/uiAction';

const validateSchema=Yup.object().shape({
				firstname: Yup.string()
						.trim()
						.required('Please enter your first name.')
						.max(50, 'First name must be at most 50 characters long.')
						.matches(/^[^<>]*$/, 'First name must not contain HTML tags.')
						.matches(/^[A-Za-z\s'\-�]+$/, "First name can only contain letters, spaces, apostrophes, and hyphens."),

					lastname: Yup.string()
						.trim()
						.required('Please enter your last name.')
						.max(50, 'Last name must be at most 50 characters long.')
						.matches(/^[^<>]*$/, 'Last name must not contain HTML tags.')
						.matches(/^[A-Za-z\s'\-�]+$/, "Last name can only contain letters, spaces, apostrophes, and hyphens."),
				});
				
const passwordSchema=Yup.object().shape({
				current_password: Yup.string()
				  .trim().required('Please enter your current password.'),
				new_password: Yup.string()
					.matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, {
                            message:'Please make sure your password meets all of the requirements.',
                            excludeEmptyString: true
                        })
				  .trim().required('Please enter a new password.'),
				   cnf_password: Yup.string()
				  .oneOf([Yup.ref('new_password'), ''], "That entry doesn't match your new password, please try again.").required('Please confirm your new password.'),
			});

class Account extends Component {	
	
	componentDidMount() {
		this.props.getUserDetails();
		this.props.hideShowPassword(false);
	}
	toggle(){
		this.props.hideShowPassword(true);
	}
	render(){
		return (
		this.props.userDetails?<div className="account-wrapper">
					<div className="container">
							<h1>PROFILE</h1>
					</div>
					<div className="container">
						<div className="col-xs-6">
                            <label aria-label="Email Address">Username / Email Address</label>
							<span className="username-detail" >{this.props.userDetails.email}</span>
                        </div>
					</div>
                    <div className="container">
						<div className="col-xs-6">
                            <label aria-label="First Name">First Name*
								<Control.text aria-required="true" model="userDetails.firstname" />
							</label>
                        </div>
						<div className="col-xs-6">
                            <label aria-label="Last Name">Last Name*
								<Control.text aria-required="true" model="userDetails.lastname" />
							</label>
                        </div>
					</div>
					<div className="container">
					
					{this.props.userDetails.user_type==='1' || this.props.userDetails.user_type==='0' ? <div className="col-xs-6">
                            <label aria-label="Bar #">{this.props.userDetails.user_type === '1' ? 'Bar #*' : 'Badge #*'}
								<Control.text aria-required="true" model="userDetails.barno" />
							</label>
                        </div>: <div></div>}
						 {!this.props.uiState.hideShowPassword? 
						<div className="col-xs-6">
							<label aria-label="Password">Password</label>
							<span className="passwordsign">********</span>
							<a href="javascript:;" className="changepassword" onClick={()=>this.toggle()}><i className="fa fa-pencil" aria-hidden="true"></i> Change Password</a>
						</div>
						 :''} 
						 {this.props.uiState.hideShowPassword? 
						 <div>
						<div className="container">
							<div className="col-xs-6">
								<label aria-label="Current Password">Current Password*
									<Control.password  model="userDetails.current_password" />
								</label>
								<div className="password-requirements-block">
									<p>Password Requirements</p>
									<ul>
										<li>An uppercase letter</li>
										<li>A lowercase letter</li>
										<li>A special character !@#$%^&*</li>
										<li>A number</li>
										<li>A minimum of 8 characters</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="container">
							<div className="col-xs-6">
								<label aria-label="New Password">New Password*
									<Control.password  model="userDetails.new_password" />
								</label>
							</div>
						</div>
						<div className="container">
							<div className="col-xs-6">
								<label aria-label="Confirm Password">Confirm Password*
									<Control.password  model="userDetails.cnf_password" />
								</label>
							</div>
						</div>
						</div>
						 :''
						} 
						
					</div> 
					<div className="container">
						<div className="col-xs-12">
                            <label aria-label="Email preferences">eService preference</label>
							<p className="eservice-description">By opting in to eService, you consent for any opposing parties of record to serve you electronically through ePortal. Any service requirements otherwise provided by law shall remain in effect.<b> This change will not affect your pending cases.  You will need to opt-in or opt-out in each of your pending cases. </b></p>
							<div  className="eservice-radio">
								{/* {console.log(this.props.userDetails)} */}
								<div className="radio-block" role="radiogroup" tabIndex="0">
									<span>
										<Control.radio model='userDetails.e_services' role="radio" id="opt-in" aria-label="Opt-in" changeAction= { (model, value)=> (dispatch) => {
                    					dispatch(actions.change('userDetails.opt_out_email', false))
										dispatch(actions.change('userDetails.e_services', '1'))
										}}  name="preference" type="radio" className="field radio" value="1" checked={this.props.userDetails.e_services==='1'}/>
										<label className="" htmlFor="opt-in" >
											<span className="choice__text">Opt-in</span>
										</label>
									</span>
									<span>
										<Control.radio model='userDetails.e_services' role="radio" id="opt-out" aria-label="Opt-out" name="preference" type="radio" className="field radio" value="0"
										changeAction= { (model, value)=> (dispatch) => { 
											dispatch(actions.change('userDetails.e_services', '0'))
											dispatch(actions.change('userDetails.opt_out_email', false))
											}
										} checked={this.props.userDetails.e_services==='0'}/>
										<label className="" htmlFor="opt-out" >
											<span className="choice__text">Opt-out</span>
										</label>
									</span>					
								</div>
							</div>
                        </div>
					</div>
					<div className="container">
						<div className="col-xs-12 dropdown">
                            <label aria-label="Email preferences">Email preferences</label>
						<p className="eservice-description">Please note, if you opt-in to eServices, you cannot turn off email notifications.</p>
							<Field model="userDetails.opt_out_email" >
								<div className="select-check">
									<span>
                  {/*<input id="Yes" name="yesno" type="checkbox" className="field radio" role="checkbox" aria-checked="true" disabled={this.props.userDetails.e_services==='1'} /> */}
										<input id="Yes" name="yesno" type="checkbox" className="field radio" role="checkbox" disabled={this.props.userDetails.e_services==='1'} />
										<label id="checkbox" className="" htmlFor="Yes" aria-labelledby="Yes checkbox">
											<span className="choice__text">Turn off email notifications.</span>
										</label>
									</span>
									
								</div>
							</Field>
                        </div>
					</div>
					
                    <div className="container">
                        <div className="col-xs-12">
                            <div className="btn-block account-btn">
                                <button aria-label="Cancel" className="cancel-btn" onClick={()=>{
							this.props.history.push('/publicAccess/dashboard');
							}}>Cancel</button>
                                <button aria-label="Save" className="save-btn" onClick={()=>{this.props.updateUserDetails(validateSchema,passwordSchema)}}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>:''
			)
		}
	}

function mapStateToProps(state) {
  return {
	  userDetails : state.userDetails||{},
	  uiState : state.uiState
  };
}

export default connect(mapStateToProps,{getUserDetails,updateUserDetails,hideShowPassword})(Account);